import { POLICY_APPLICATIONS, DAY_IN_SECONDS } from '@kentik/ui-shared/alerting/constants';

export const DEFAULT_POLICY_TYPES = [
  POLICY_APPLICATIONS.DDOS,
  POLICY_APPLICATIONS.CORE,
  POLICY_APPLICATIONS.CLOUD,
  POLICY_APPLICATIONS.METRIC
];

export const DEFAULT_LOOKBACK_SECONDS = DAY_IN_SECONDS * 90;

export const ALERTING_TRENDS_SHORTCUTS = [
  {
    label: 'Last 24 hours',
    lookbackSeconds: DAY_IN_SECONDS,
    value: DAY_IN_SECONDS,
    includeTime: true,
    isKeyword: true
  },
  {
    label: 'Last 7 days',
    lookbackSeconds: DAY_IN_SECONDS * 7,
    value: DAY_IN_SECONDS * 7,
    includeTime: true,
    isKeyword: true
  },
  {
    label: 'Last 14 days',
    lookbackSeconds: DAY_IN_SECONDS * 14,
    value: DAY_IN_SECONDS * 14,
    includeTime: true,
    isKeyword: true
  },
  {
    label: 'Last 30 days',
    lookbackSeconds: DAY_IN_SECONDS * 30,
    value: DAY_IN_SECONDS * 30,
    includeTime: true,
    isKeyword: true
  },
  {
    label: 'Last 90 days',
    lookbackSeconds: DAY_IN_SECONDS * 90,
    value: DAY_IN_SECONDS * 90,
    includeTime: true,
    isKeyword: true
  }
];
